import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';
import VerificationsList from './VerificationsList';
import VerificationShow from './VerificationShow';


export default {
    list: VerificationsList,
    icon: LoggingIcon,
    show: VerificationShow,
}